<template>
  <div>
    <div class="gallery">
      <div v-for="(item, index) in images" :key="item.id">
        <b-button
          class="no-print"
          style="position: absolute; z-index: 2"
          variant="danger"
          title="Remover Imagem"
          @click="Remover(item)"
        >
          <i class="fas fa-trash-alt"></i>
        </b-button>
        <img
          class="gallery-item"
          :src="$store.getters.baseURL + 'arquivo/get/' + item.fileId"
          @click="openPopup(item.fileId, index)"
        />
      </div>
    </div>
    <div class="no-print" v-if="isPopupOpen" id="popup">
      <span class="close" @click="closePopup"
        ><i class="fas fa-times"></i
      ></span>

      <img :src="imagePopup" alt="Imagem" />
      <div class="d-flex justify-content-center mt-2">
          <button
            type="button"
            class="btn btn-secondary"
            title="Anterior"
            @click="back"
          >
            <i class="fas fa-chevron-left"></i>
          </button>
          <button
            type="button"
            class="btn btn-secondary"
            title="Próximo"
            @click="next"
          >
            <i class="fas fa-chevron-right"></i>
          </button>
      </div>
    </div>

    <b-modal
      v-model="modalRemover"
      title="Confirmar exclusão"
      class="modal-danger"
      ok-variant="danger"
      @ok="ModalOk"
      @hidden="ModalCancel"
    >
      Você confirma a exclusão da imagem?
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "GalleryImage",
  components: {
  },
  props: {
    removeEmit: {
      type: String,
      default: ""
    },
    images: {
      type: Array,
      defaul: []
    }
  },
  data() {
    return {
      isPopupOpen: false,
      modalRemover: false,
      itemRemover: null,
      imagePopup: null,
      index: 0
    };
  },
  methods: {
    next() {
      if (this.index == this.images.length - 1) return;
      this.index += 1;

      this.imagePopup =
        this.$store.getters.baseURL +
        "arquivo/get/" +
        this.images[this.index].fileId;
    },
    back() {
      if (this.index == 0) return;

      this.index -= 1;
      this.imagePopup =
        this.$store.getters.baseURL +
        "arquivo/get/" +
        this.images[this.index].fileId;
    },
    openPopup(fileId, index) {
      this.index = index;
      this.imagePopup = this.$store.getters.baseURL + "arquivo/get/" + fileId;
      this.isPopupOpen = true;
    },
    closePopup() {
      this.index = 0;
      this.imagePopup = null;
      this.isPopupOpen = false;
    },
    ModalCancel(evento) {
      evento.preventDefault();
      this.itemRemover = null;
    },
    ModalOk(evento) {
      evento.preventDefault();
      this.modalRemover = false;
      if (!this.itemRemover) return;

      this.$emit(this.removeEmit, this.itemRemover);
      this.itemRemover = null;
    },
    Remover(item) {
      this.modalRemover = true;
      this.itemRemover = item;
    }
  }
};
</script>

<style>
.gallery {
  display: flex;
  flex-direction: row; /* Altera a orientação da galeria para linha (esquerda para direita) */
  flex-wrap: wrap;
}

.gallery-item {
  flex: 0 0 auto; /* Define o tamanho automático dos itens da galeria */
  width: 200px;
  height: 200px;
  margin: 10px;
  transition: transform 0.3s;
}

.gallery-item:hover {
  transform: scale(1.1);
  z-index: 1;
}
#popup {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  padding: 20px;
  border: 1px solid black;
  z-index: 9999;
  max-height: 95%;
  overflow-y: auto; 
}

#popup img {
  max-width: 100%;
  height: auto;
}

#popup .close {
  position: absolute;
  top: 4px;
  right: 3px;
  cursor: pointer;
}
</style>